import React from "react";
import { ComponentI } from "../../../../types";
import Card from "../../../../componentLibrary/Card";
import Input from "../../../../componentLibrary/Input";
import Textarea from "../../../../componentLibrary/Textarea";
import Checkbox from "../../../../componentLibrary/Checkbox";
import { CopyVariableButton } from "../../utils/CopyVariableButton";

export default function InputContentCard({
  component,
  handleContentChange,
}: {
  component: ComponentI;
  handleContentChange: (
    id: string,
    field: string,
    value: string | boolean,
  ) => void;
}) {
  return (
    <Card>
      <div className="space-y-2">
        <Input
          value={component.content.label}
          onChange={(e) =>
            handleContentChange(component._id, "label", e.target.value)
          }
          label="Label"
          placeholder="Write a way that you can support your partner"
        />
        <Textarea
          value={component.content.placeholder}
          onChange={(e) =>
            handleContentChange(component._id, "placeholder", e.target.value)
          }
          label="Placeholder"
          placeholder="I can cook dinner"
        />
        <div className="flex space-x-4">
          <Checkbox
            label="Allow Converting Placeholder Text"
            checked={component.content.convertPlaceholder !== false}
            onChange={(e) =>
              handleContentChange(
                component._id,
                "convertPlaceholder",
                e.target.checked,
              )
            }
          />
          <Checkbox
            label="Integer Values Only"
            checked={component.content.integerOnly === true}
            onChange={(e) =>
              handleContentChange(
                component._id,
                "integerOnly",
                e.target.checked,
              )
            }
          />
        </div>
        <Input
          value={component.content.variable}
          onChange={(e) =>
            handleContentChange(component._id, "variable", e.target.value)
          }
          label="Variable Name"
          placeholder="support_partner"
          required
          TopRightElement={
            <CopyVariableButton type="icon" component={component} />
          }
        />
      </div>
    </Card>
  );
}
